import React from 'react';
import { Form, Input, Button, notification, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import { warningsApi } from '../apiCalls/warningsApi';
import PageTitle from '../components/PageTitle';

const AddWarningForm: React.FC = () => {
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    const warningData = {
      ...values,
    };

    const result = await warningsApi.createWarning(warningData);
    if (result) {
      notification.success({
        message: 'Warning Created',
        description: 'The warning has been created successfully.',
        duration: 3,
      });
      navigate('/warnings');
    } else {
      notification.error({
        message: 'Error al Crear',
        description: 'Hubo un error al crear el warning.',
        duration: 3,
      });
    }
  };

  return (
      <div style={{ padding: 24 }}>
        <PageTitle title="Add new warning" />
        <Form layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Name" name="name" rules={[{ required: true }]}>
                <Input placeholder="Enter the name" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Add Warning
            </Button>
          </Form.Item>
        </Form>
      </div>
  );
};

export default AddWarningForm;
